<template>
	<div class="nav-all">
		<div class="nav-cont">
			<div class="nav-left">
				<img class="logo-img" :src="$store.state.basePicUrl + 'image/base/logo.png'">
				<div class="line"></div>
				<div class="left-major">
					<div class="name-div" @click="changeMajor">
						<span class="jobName-span">{{jobName}}-{{majorName}}</span>
						<img class="sel-img" :src="$store.state.basePicUrl + 'image/base/sel.png'">
					</div>
					<div class="major-div" v-if="majorShow">
						<div>
							<div class="major-left" :class="item.job.id == jobId?'job-sel':''"
								v-for="(item,index) in majorList" :key="index" @click="jobClick(item,index)">
								{{item.job.name}}
							</div>
						</div>
						<div>
							<div class="major-right" v-for="(item,index) in majorList" :key="index">
								<div class="major-item" :class="tem.id==majorId?'major-sel':''"
									v-if="item.job.id == jobId" v-for="(tem,dex) in item.major" :key="dex"
									@click="majorSel(tem,dex)">
									{{tem.name}}
									<img v-if="tem.id==majorId" class="checked-img"
										:src="$store.state.basePicUrl + 'image/base/checked.png'">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="nav-right">
				<p v-for="(item,index) in navList" :key="index" @click="navUrl(index)">
					<router-link class="a-p" :class="{ active: current == index }" :to="item.path">{{item.name}}
					</router-link>
				</p>
				<div class="search-div">
					<input class="search-input" placeholder="输入课程关键词" v-model="searchVal" />
					<div class="search-right" @click="search">
						<img class="search-img" :src="$store.state.basePicUrl + 'image/base/search.png'">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getMajors
	} from "@/api/home.js"
	export default {
		data() {
			return {
				// majorName: "",
				majorList: [],
				majorShow: false,
				current: 0,
				searchVal: "",
				jobId: 0,
				majorId: 0,
				jobName: "",
				majorName: "",
				navList: [{
						name: "首页",
						path: "/"
					},
					{
						name: "课程",
						path: "/course"
					},
					{
						name: "题库",
						path: "/question"
					},
					{
						name: "资讯",
						path: "/information"
					},
					{
						name: "常用网站",
						path: "/website"
					},
					// {
					// 	name: "社区",
					// 	path: "/community"
					// },
					// {
					// 	name: "商城",
					// 	path: "/shopping"
					// },
					{
						name: "个人中心",
						path: "/personal?selTab=myCourse"
					}
				]
			}
		},
		mounted() {
			this.getMajors();
		},
		watch: {
			"$store.state.majorId"() {
				this.majorId = this.$store.state.majorId;
				this.getMajors();
			}
		},
		methods: {
			getMajors() {
				getMajors({}).then(data => {
					this.majorList = data.result;
					let isMajor = this.majorList.some(item => {
						if (this.$store.state.jobId == item.job.id) {
							return item.major.some(tem => {
								if (tem.id == this.$store.state.majorId) {
									return true;
								}
							})
						}
					})
					if (isMajor) {
						data.result.forEach((item) => {
							if (this.$store.state.jobId == item.job.id) {
								this.jobName = item.job.name;
								this.jobId = item.job.id;
							}
							item.major.forEach(tem => {
								if (this.$store.state.majorId == tem.id) {
									this.majorName = tem.name;
									this.majorId = tem.id;
								}
							})
						})
					} else {
						this.jobName = this.majorList[0].job.name;
						this.majorName = this.majorList[0].major[0].name;
						this.jobId = this.majorList[0].job.id;
						this.$store.state.jobId = this.majorList[0].job.id;
						this.majorId = this.majorList[0].major[0].id;
						this.$store.state.majorId = this.majorList[0].major[0].id;
					}
				})
			},
			jobClick(item, index) {
				if (this.majorList[index].major && this.majorList[index].major.length) {
					this.jobId = item.job.id;
					this.$store.state.jobId = item.job.id;
					this.jobName = item.job.name;
					this.majorName = this.majorList[index].major[0].name;
					this.majorId = this.majorList[index].major[0].id;
					this.$store.state.majorId = this.majorList[index].major[0].id;
				} else {
					this.$message.warning("该科目下无分类不可选择！");
				}
			},
			majorSel(tem, dex) {
				this.majorId = tem.id;
				this.$store.state.majorId = tem.id;
				this.majorName = tem.name;
				this.majorShow = !this.majorShow;
			},
			changeMajor() {
				this.majorShow = !this.majorShow;
			},
			navUrl(index) {
				this.current = index;
			},
			search() {
				console.log(this.searchVal);
				this.$router.push({
					path: "/course",
					query: {
						name: this.searchVal
					}
				})
			},
		}
	}
</script>

<style scoped>
	.nav-all {
		width: 100%;
		background: #FFFFFF;
		height: 84px;
	}

	.nav-cont {
		width: 1200px;
		margin: 0 auto;
		height: 84px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.nav-left {
		display: flex;
		align-items: center;
	}

	.logo-img {
		/* width: 146px; */
		height: 44px;
	}

	.line {
		width: 1px;
		height: 40px;
		background: #F0F0F2;
		border-radius: 6px;
		margin: 0 20px;
	}

	.left-major {
		display: flex;
		align-items: center;
		cursor: pointer;
		position: relative;
	}

	.name-div {
		display: flex;
		align-items: center;
	}

	.jobName-span {
		max-width: 300px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.sel-img {
		width: 18px;
		height: 19px;
		margin-left: 8px;
	}

	.major-div {
		width: 427px;
		min-height: 200px;
		padding: 17px 10px;
		position: absolute;
		top: 40px;
		left: -50px;
		background: #FFFFFF;
		box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.5);
		border-radius: 4px;
		border: 1px solid #F0F0F2;
		z-index: 5;
		display: flex;
	}

	.major-left {
		width: 195px;
		/* min-height: 48px; */
		display: flex;
		align-items: center;
		background: #F4F4F5;
		padding: 15px 12px;
		box-sizing: border-box;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #1D2023;
	}

	.job-sel {
		background: #FFFFFF;
	}

	.major-sel {
		color: #C51E00;
	}

	.major-right {}

	.major-item {
		width: 220px;
		height: 40px;
		display: flex;
		justify-content: space-between;
		padding: 0 20px;
		box-sizing: border-box;
		align-items: center;
	}

	.nav-right {
		display: flex;
		align-items: center;
	}

	.a-p {
		padding-right: 32px;
		text-decoration: none;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #1D2023;
	}

	.active {
		color: #C51E00;
	}

	.search-div {
		width: 196px;
		height: 36px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #C51E00;
		position: relative;
	}

	.search-input {
		width: 160px;
		height: 36px;
		border-radius: 4px;
		border: none;
		outline: none;
		padding: 0 12px;
		box-sizing: border-box;
	}

	.search-right {
		width: 36px;
		height: 36px;
		background: #C51E00;
		position: absolute;
		right: 0;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.search-img {
		width: 18px;
		height: 18px;
	}
</style>



// WEBPACK FOOTER //
// src/components/base/navLi.vue